<template  >
<v-layout column full-width class="">
    <not-toolbar-sub :not="not"></not-toolbar-sub>
</v-layout>
</template>

<script> 
    
   let pageName = 'Home'
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
             
        }), 
        beforeCreate(){
             
        },
        created(){
             
        },
        mounted() {   
            
        },
        computed:{ 
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            
        },
        //------------methods---------------
        methods: { 
          pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {  
                        
                        this.page_show = true
                    } 
 
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
